import '../../Report.css'
import './GoalItem.css'

export type GoalItemProps = {
  index: number
  title: string
}

const GoalItem = (props: GoalItemProps & { dark: boolean }) => {
  const textColor = props?.dark ? '#ffffff' : '#212121'

  return (
    <div
      className={'row goal-item-box'}
      style={props.dark ? {} : { backgroundColor: '#F2F2F2' }}
    >
      <div
        className={props?.dark ? 'num-dot-item-inverted' : 'num-dot-item'}
        style={{ marginRight: 30 }}
      >
        {props.index}
      </div>
      <p
        className={'inverted-text goal-item-title'}
        style={{ color: textColor }}
      >
        {props.title}
      </p>
    </div>
  )
}

export default GoalItem
